import { OperationFront } from '../../../shared/types/operation.ts';
import { getConfirmedScraps } from '../../../shared/utils/scrapUtils.ts';
import { formatDate, formatDatetime } from '../../utils/fieldFormats.ts';
import { HandledScrapsFilters } from './handledScrapFilters.ts';
import { ScrapTotals } from './useScrapTotal.ts';


export function createExportTable(
    filters: HandledScrapsFilters,
    operations: OperationFront[],
    scrapTotals: ScrapTotals,
): Array<Array<string | number>> {
    if (filters == null || operations == null || scrapTotals == null) {
        throw new Error('Filters, operations, and scrap totals must be defined to create the table.');
    };

    const queryFilters = filters.queryFilters;
    const filtersSection = [
        ['Part number:', queryFilters.partDisplayName.trim() ?? ''],
        ['Order number:', queryFilters.orderNumber.trim() ?? ''],
        ['Start date:', queryFilters.startDate ? formatDate(queryFilters.startDate) : ''],
        ['End date:', queryFilters.endDate ? formatDate(queryFilters.endDate) : ''],
    ];

    const scrapTotalsSection = [
        ['Cases:', scrapTotals?.numCases ?? ''],
        ['Initial scraps:', scrapTotals?.initialScraps ?? ''],
        ['Potential scraps:', scrapTotals?.potentialScraps ?? ''],
        ['Confirmed scraps:', scrapTotals?.confirmedScraps ?? ''],
        ['Released scraps:', scrapTotals?.releasedScraps ?? ''],
    ];

    const operationsHeader = [
        'Equipment',
        'Part number',
        'Program',
        'Operation performed',
        'Operation comment',
        'Order number',
        'Initial scraps',
        'Potential scraps',
        'Confirmed scraps',
        'Part count',
        'Operation date',
        'Operation operator',
        'Scrap reason',
        'Close comment',
        'Close operator',
        'Close date',
        'Time spent',
    ];
    const operationsData = operations.map((operation) => {
        const scrapCloseForm = operation.scrapCloseForm;
        const scrapReview = operation.scrapReview;

        const timeSpentHours = Math.floor((scrapCloseForm?.timeSpent ?? 0) / 60_000 / 60);
        const timeSpentMinutes = Math.floor((scrapCloseForm?.timeSpent ?? 0) / 60_000 % 60);
        const timeSpent = scrapCloseForm?.timeSpent != null ? `${timeSpentHours}h ${timeSpentMinutes}m` : '';

        return [
            operation.equipmentDisplayName,
            operation.partDisplayName ?? '',
            operation.product ?? '',
            operation.details.join(' > '),
            operation.comment ?? '',
            operation.orderNumber ?? '',
            operation.confirmedScraps ?? 0,
            operation.potentialScraps ?? 0,
            getConfirmedScraps(operation),
            operation.partCount ?? 0,
            formatDatetime(operation.effectiveTime),
            operation.operator ?? '',
            scrapCloseForm?.scrapReason ?? '',
            scrapCloseForm?.comment ?? scrapReview?.comment ?? '',
            scrapCloseForm?.operator ?? scrapReview?.operator ?? '',
            formatDatetime(scrapCloseForm?.time ?? scrapReview?.time),
            timeSpent,
        ];
    });

    const finalTable = [
        ['Filters'],
        ...filtersSection,
        [''],
        ['Scrap totals'],
        ...scrapTotalsSection,
        [''],
        ['Operations'],
        operationsHeader,
        ...operationsData,
    ]
    return finalTable;
}
